(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentTypeGroupsSearchService',
		[
			'$http',
			'pxUriPathService',
			'smbContentTypeAcls',
			ContentTypeGroupsSearchService
		]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypeGroupsService
	 * 
	 * @description
	 * A service that exposes methods for creating and updating content type groups.
	 */
	function ContentTypeGroupsSearchService($http, pxUriPathService, smbContentTypeAcls) {

		return {
			/**
			 * @ngdoc method
			 * @name smbContentTypeGroupsService#createContentTypeGroup
			 * @methodOf smb-app.smbContentTypeGroupsService
			 * @kind function
			 * 
			 * @description
			 * Creates a new content type group in the system.
			 * 
			 * @param {Object} group An object representing the content type group to create
			 *
			 * @returns {Promise} A promise that resolves to the newly created content type group
			 */
			getAllContentTypeGroups: getAllContentTypeGroups,

			/**
			 * @ngdoc method
			 * @name smbContentTypeGroupsService#createContentTypeGroup
			 * @methodOf smb-app.smbContentTypeGroupsService
			 * @kind function
			 * 
			 * @description
			 * Saves changes made to an existing content type group
			 * 
			 * @param {Object} group An object that represents an existing content type group
			 * 
			 * @returns {Promise} A promise that resolves to the content type group that was changed
			 */
			getFullAccessContentTypeGroups: getFullAccessContentTypeGroups
		};

		function getAllContentTypeGroups() {
			return $http.get(pxUriPathService.resolvePath('/libraries?acl=' + smbContentTypeAcls.READ_DOCUMENTS))
				.then(function (res) { return res.data.filter(function (lib) {
					return !lib.IsPrivate;
				}); 
			});
		}

		function getFullAccessContentTypeGroups() {
			return $http.get(pxUriPathService.resolvePath('/libraries?acl=' + smbContentTypeAcls.CREATE_DOCUMENTS))
				.then(function (res) { return res.data.filter(function (lib) {
					return !lib.IsPrivate;
				}); 
			});
		}	
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/contentTypeGroupsSearchService.js
// module id = 142
// module chunks = 1